import { render, staticRenderFns } from "./VoucherInspector.vue?vue&type=template&id=88ca4ef6"
import script from "./VoucherInspector.vue?vue&type=script&lang=js"
export * from "./VoucherInspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports